import React from "react";
import { connect } from "react-redux";
import { func } from "prop-types";

import PageContent from "../PageContent";
import { go } from "../../logic/actions/navigation";
import { FACE_CAPTURE } from "../../logic/enums/pages";
import selfieVideo from "../../assets/videos/01-selfie.mp4";
import selfiePoster from "../../assets/videos/01-selfie.jpg";

PageInstructionVideoSelfie.propTypes = {
  go: func,
};

export function PageInstructionVideoSelfie(props) {
  const videoStyle = { width: "75%", height: "75%" };
  return (
    <PageContent>
      <h1 style={{ margin: "5px" }}>Instruction Video</h1>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <video loop autoPlay playsInline style={videoStyle} poster={selfiePoster}>
          <source src={selfieVideo} type="video/mp4"/>
          Your browser does not support the video tag.
        </video>
      </div>
      <button className="btn green" onClick={() => props.go(FACE_CAPTURE)}>
        Start
      </button>
    </PageContent>
  );
}

export default connect(null, { go })(PageInstructionVideoSelfie);
